/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 2.3.2016
 */


(function ($, dis) {
	"use strict";


	dis.Accordion = function () {
		dis.BaseModule.call(this);

		var dom = {},
			selfScope = this;


		function init() {
			dom.trigger = $(".accordion-box__content__item > input");

			dom.trigger.change(function () {
				var current = $(this),
					parent,
					position,
					positionInWindow;

				if (current.is(":checked")) {
					parent = current.parent();
					position = parent.offset().top;
					positionInWindow = position - selfScope.globalDOM.window.scrollTop();

					if (positionInWindow < 0) {
						$("html, body").animate({
							scrollTop: position
						});
					}
				}
			});
		}

		selfScope.onReady(init);
	};

	dis.Accordion.prototype = new dis.BaseModule();
	dis.Accordion.constructor = dis.Accordion;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));